import Spinner from '@modules/common/icons/spinner'
import clsx from 'clsx'
import React from 'react'

type ButtonProps = {
  isLoading?: boolean
  variant?: 'primary' | 'secondary'
} & React.ButtonHTMLAttributes<HTMLButtonElement>

const Button = ({
  children,
  className,
  isLoading = false,
  variant = 'primary',
  ...props
}: ButtonProps) => {
  return (
    <button
      {...props}
      className={clsx(
        'uppercase flex items-center justify-center min-h-[50px] px-5 py-[10px] text-small-regular border transition-colors duration-300 disabled:opacity-50',
        {
          'text-white bg-bh-black border-bh-black hover:bg-gray-600 disabled:hover:bg-bh-black disabled:hover:text-white':
            variant === 'primary',
          'text-bh-black bg-transparent border-gray-900 hover:border-white':
            variant === 'secondary',
        },
        className
      )}
    >
      {isLoading ? <Spinner /> : children}
    </button>
  )
}

export default Button
